'use strict';

var ww, wh, sw, sh, ws;

function us(){//update window size
    ww = $(window).width();
    //ww = Math.max(1024,ww);
    wh = $(window).height();
    sw = screen.width;
    sh = screen.height;
    //ws = $(window).scrollTop();
    ws = $(document).scrollTop();
    //ws = window.pageYOffset;
}
function nopx(s){
    if(s=="undefined" || s==null){
        s="0";
    }
        var i = parseInt(s.replace("px", "") );
        return Number(i);

}
function nl2br (str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
}
function nl2br2 (str, is_xhtml) {   //for markdown only
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br class="br"/>' : '<br class="br">';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
}
function nlRemove (str) {
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ '' +'$2');
}

function ofRandom(a, b) {
	return Math.random()*(b-a)+a;
}
function ofMap(X, A, B, C, D, isClamp) {
	var Y = (X-A)/(B-A) * (D-C) + C;
	if(isClamp){
		Y = ofClamp(Y, C, D);
	}
	return Y;
}
function ofClamp(v, a, b) {
	if(a>b){
		var a2 = a;
		a=b;
		b=a2;
	}
	return Math.min(Math.max(v,a),b) ;
}

export {
  ofClamp,
  ofRandom,
  ofMap,
};



// WEBPACK FOOTER //
// ./src/p.js